module.exports = __webpack_public_path__ + "static/media/m_beard_tailored_round__oval_shadow.e354b409.png";